import { render, staticRenderFns } from "./DiagnosticList.vue?vue&type=template&id=a6471b6c&scoped=true&"
import script from "./DiagnosticList.vue?vue&type=script&lang=js&"
export * from "./DiagnosticList.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticList.vue?vue&type=style&index=0&id=a6471b6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6471b6c",
  null
  
)

export default component.exports